import { Proposal } from "../types/Proposal";
import { PartialRecord } from "../types/GeneralTypes";

export const KorterConverter:PartialRecord<keyof Proposal, (input:any) => unknown> = {
    link: (link:string) => {
        return "https://korter.ge" + link;
    },
    type: (type: string) => {
        switch (type) {
            case 'Studio':
                return 'STUDIO';
            case '1':
                return 'ONE'
            case '2':
                return '2_BEDROOM'
            case '3':
            case '4+':
            default:
                return '3_BEDROOM'
        }
    }
}